import React, { useState, useEffect } from "react";
import "./Dashboard.css";

const CITIES = [
  { id: 'toronto', name: 'Toronto' },
  { id: 'new-york', name: 'New York' },
  { id: 'boston', name: 'Boston' },
  { id: 'chicago', name: 'Chicago' },
  { id: 'new-orleans', name: 'New Orleans' },
  { id: 'miami', name: 'Miami' },
  { id: 'austin', name: 'Austin' },
  { id: 'dallas', name: 'Dallas' },
  { id: 'houston', name: 'Houston' }
];

export default function OrderWidget() {
  const [selectedCity, setSelectedCity] = useState('toronto');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // TODO: Implement orders API when ready
    // For now, show placeholder data
    setOrders([]);
  }, [selectedCity]);

  return (
    <div className="widget">
      <div className="widget-header">
        <h2 className="widget-title" style={{ color: 'rgba(130, 67, 67, 1)' }}>Orders</h2>
        <div className="city-pills">
          {CITIES.map(city => (
            <button
              key={city.id}
              className={`city-pill ${selectedCity === city.id ? 'active' : ''}`}
              onClick={() => setSelectedCity(city.id)}
            >
              {city.name}
            </button>
          ))}
        </div>
      </div>

      <ul className="widget-list">
        <li className="no-data">
          Orders system coming soon for {CITIES.find(c => c.id === selectedCity)?.name}
        </li>
      </ul>
    </div>
  );
}
